import { createSelector } from 'reselect';

const getState = state => state.programSetup;

const getRawPrograms = createSelector([getState], state => state.data);

const getProgramsById = createSelector([getRawPrograms], state => state.byId);

const getSelectedProgram = createSelector([getState], state => state.selectedProgram);

const isUploading = createSelector([getState], state => state.uploading);

const getProgramId = createSelector([getSelectedProgram], program => program?.id);

const getCertificateLogo = createSelector(
  [getSelectedProgram],
  program => program?.certificate_logo_file || program?.certificate_logo
);

export default {
  getProgramsById,
  getSelectedProgram,
  isUploading,
  getProgramId,
  getCertificateLogo,
};
